import moment from 'moment-timezone'

export const getTimezoneLabel = (timezonesList, timezone = moment.tz.guess()) => {
  const localTZ = timezonesList.find(tz => tz.timezone === timezone)
  return localTZ ? localTZ.label : ''
}
